import { useLocation } from "react-router-dom";
import { screens } from "./../utils";
import { Link } from "react-router-dom";
const Header = () => {
  const location = useLocation();
  return (
    <>
      {/*  <div className="container-fluid bg-dark p-0">
        <div className="row gx-0 d-none d-lg-flex">
          <div className="col-lg-7 px-5 text-start">
            <div className="h-100 d-inline-flex align-items-center me-4">
              <small className="fa fa-map-marker-alt text-primary me-2"></small>
              <small>
                {config.address1} {config.address2} {config.address3}
              </small>
            </div>
          </div>
          <div className="col-lg-5 px-5 text-end">
            <div className="h-100 d-inline-flex align-items-center me-4">
              <small className="fa fa-phone-alt text-primary me-2"></small>
              <small>{config.phoneNo}</small>
            </div>
            <div className="h-100 d-inline-flex align-items-center mx-n2">
              {socials.map((social, index) => {
                return (
                  <a
                    className="btn btn-square btn-link rounded-0 border-0 border-end border-secondary"
                    href={social.url}
                    key={index}
                    target="_blank"
                  >
                    <i className={`fab ${social.icon}`}></i>
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div> */}
      <nav className="navbar navbar-expand-lg bg-white navbar-light sticky-top p-0">
        <a
          href="/"
          className="navbar-brand d-flex align-items-center border-end px-4 px-lg-5"
        >
          {/*  <h2 className="m-0 text-primary">{config.appName}</h2> */}
          <img src="./../../img/logo.jpg" alt={"Logo"} />
        </a>
        <button
          type="button"
          className="navbar-toggler me-4"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav ms-auto p-4 p-lg-0">
            {screens.map((menu, index) => {
              return (
                <Link
                  to={menu.url}
                  className={`nav-item nav-link ${
                    location.pathname === menu.url ? `active` : ""
                  }`}
                  key={index}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  {menu.pageName}
                </Link>
              );
            })}
          </div>
          <Link
            to="/donate"
            className="btn btn-primary rounded-0 py-4 px-lg-5 d-none d-lg-block"
          >
            Donate<i className="fa fa-arrow-right ms-3"></i>
          </Link>
        </div>
      </nav>
    </>
  );
};
export default Header;
